import { Component, OnInit } from '@angular/core';
import { CallHistoryService } from '../../call-history.service';
import { CallHistorySearchParams } from '../../call-history-params.interface';
import { getCallHistoryPageSelector } from '../../call-history.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-all-missed-calls-filter',
  templateUrl: './all-missed-calls-filter.component.html',
  styleUrls: ['./all-missed-calls-filter.component.scss']
})
export class AllMissedCallsFilterComponent implements OnInit {
  public filters: CallHistorySearchParams;
  public allMissedForm = new FormControl();

  constructor(private callHistoryService: CallHistoryService, private store: Store<IState>) {}

  ngOnInit() {
    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      this.filters = params;
      this.allMissedForm.setValue(this.filters.onlyMissed ? 1 : 0);
    });
  }

  addFilter(type, value) {
    this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
  }
}
